import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const CheckEmailPage = withSuspense(lazy(() => import('./check-email-page.component')));
